import { render, staticRenderFns } from "./DenseAlert.vue?vue&type=template&id=3deb5822&"
import script from "./DenseAlert.vue?vue&type=script&lang=js&"
export * from "./DenseAlert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports